import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import {
    faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook,
    faTwitter, faInstagram, faMedium, faBehance, faDribbble,
    faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud
} from '@fortawesome/free-brands-svg-icons';
import '../styles/TemplateNine.css';

const TemplateNine = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud,
        website: faLink, // Generic link icon for website
        portfolio: faLink // Generic link icon for portfolio
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud',
        website: 'Website',
        portfolio: 'Portfolio'
    };

    return (
        <div className="template-nine" onClick={() => onClick(template?.id)} >
            <div className="template-nine-header" >
                <div className="template-nine-image-container">
                    {template?.image && <img src={template?.image} alt={template?.personName} className="template-four-image" />}
                </div>
                <div className="template-nine-name-title">
                    {template?.name && <h1 className="template-nine-name" >{template?.name}</h1>}
                </div>
            </div>

            <div className="template-nine-body">
                <div className="template-nine-columns">
                    <div className="template-nine-column-left">

                        {template.contact && (
                            <div className="template-nine-contact template-nine-section">
                                <h3>Contact</h3>
                                {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                                {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                                {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                            </div>
                        )}

                        {template?.skills && template?.skills.length > 0 && (
                            <div className="template-nine-skills template-nine-section">
                                <h3 >Skills</h3>
                                <ul>
                                    {template?.skills.map((skill, index) => (
                                        <li key={index}>{skill}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template?.softwareSkills && template?.softwareSkills.length > 0 && (
                            <div className="template-nine-software-skills template-nine-section">
                                <h3 >Software Skills</h3>
                                <ul>
                                    {template?.softwareSkills.map((skill, index) => (
                                        <li key={index}>{skill}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {template?.languages && template?.languages.length > 0 && (
                            <div className="template-nine-languages template-nine-section">
                                <h3 >Languages</h3>
                                <p>{template?.languages.join(', ')}</p>
                            </div>
                        )}
                    </div>

                    <div className="template-nine-column-right ">
                        {template?.aboutMe && template?.aboutMe.length > 0 && (
                            <div className="template-nine-about-me template-nine-section template-nine-education-item">
                                <h3 >About Me</h3>
                                <p>{template?.aboutMe}</p>
                            </div>
                        )}

                        {template?.workExperience && template?.workExperience.length > 0 && (
                            <div className="template-nine-experience template-nine-section">
                                <h3 >Experience</h3>
                                {template?.workExperience.map((experience, index) => (
                                    <div key={index} className="template-nine-experience-item">
                                        <p className="template-nine-role" >{experience.role}</p>
                                        <p className="template-nine-company">{experience.company}</p>
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                        <p className="template-nine-description">{experience.description}</p>
                                    </div>
                                ))}
                            </div>
                        )}

                        {template?.education && template?.education.length > 0 && (
                            <div className="template-nine-education template-nine-section">
                                <h3 >Education</h3>
                                {template?.education.map((edu, index) => (
                                    <div key={index} className="template-nine-education-item">
                                        <p className="template-nine-degree">{edu.degree}</p>
                                        <p className="template-nine-institution">{edu.institution}</p>
                                        <p>
                                            (
                                            {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                        <p className="view-template-eight-institution">{edu.description}</p>
                                    </div>
                                ))}
                            </div>
                        )}

                        {template?.certificates && template?.certificates.length > 0 && (
                            <div className="template-nine-education template-nine-section">
                                <h3 >Certificates</h3>
                                {template?.certificates.map((certification, index) => (
                                    <div key={index} className="template-nine-education-item">
                                        <p className="template-nine-degree">Title: {certification.title}</p>
                                        <p className="template-nine-issuer">Institution: {certification.issuer}</p>
                                        <p className="template-nine-date">
                                            Date Received: {new Date(certification.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}

                        {template?.hobbies && template?.hobbies.length > 0 && (
                            <div className="template-nine-hobbies template-nine-section template-nine-education-item">
                                <h3 >Hobbies</h3>
                                <p>{template?.hobbies.join(', ')}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="template-nine-footer">
                    {template?.links && template?.links.length > 0 && (
                        <div className="template-nine-links">
                            <h3>Links:</h3>
                            <div className='template-nine-links-place'>
                                {template.links.map(([key, value]) => (
                                    <p key={key}>
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer">{linkText[key]}</a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default TemplateNine;
